/* prettier-ignore */
/**
 * NOTE:
 *
 * This file is automatically generated by Traduki 2.0.
 * DO NOT CHANGE IT BY HAND or your changes will be lost.
 */
//German (Germany)
export default {
  'fabric.editor.ai.commandPalette.footer.atlassianIntelligenceCopyright': 'Bereitgestellt von Atlassian Intelligence',
  'fabric.editor.ai.commandPalette.footer.atlassianIntelligenceCopyrightShort':
    'Bereitgestellt von Atlassian Intelligence',
  'fabric.editor.ai.commandPalette.footer.disclaimerText':
    'Der Inhalt basiert auf Ihren Berechtigungen und seine Qualität kann variieren.',
  'fabric.editor.ai.commandPalette.footer.disclaimerTextShort': 'Die Qualität der Inhalte kann variieren.',
  'fabric.editor.ai.commandPalette.footer.disclaimerTextUpdated': 'Nutzt KI. Überprüfen Sie die Ergebnisse.',
  'fabric.editor.ai.commandPalette.footer.infoIconLabel': 'Informationen',
  'fabric.editor.ai.commandPalette.footer.rovoCopyright': 'Rovo',
  'fabric.editor.ai.commandPalette.footer.usePageKnowledgeToggleLabel': 'Wissen aus aktueller Seite einbeziehen',
  'fabric.editor.ai.commandPalette.promptForm.logo': 'Logo von Atlassian Intelligence',
  'fabric.editor.ai.components.backIconButton.backLabel': 'Zurück',
  'fabric.editor.ai.components.cancelEscButton.cancelLabel': 'Abbrechen',
  'fabric.editor.ai.components.cancelEscButton.escLabel': 'Esc',
  'fabric.editor.ai.components.cancelIconButton.cancelLabel': 'Abbrechen',
  'fabric.editor.ai.components.cancelIconButton.cancelTooltip': 'Abbrechen',
  'fabric.editor.ai.components.feedbackForm.badResponse': 'Schlechte Antwort',
  'fabric.editor.ai.components.feedbackForm.feedbackSent': 'Feedback wurde gesendet',
  'fabric.editor.ai.components.feedbackForm.goodResponse': 'Gute Antwort',
  'fabric.editor.ai.config.item.action.continueFromLatestResponse': 'Mit der letzten Antwort fortfahren',
  'fabric.editor.ai.config.item.action.copyResponse': 'Kopieren',
  'fabric.editor.ai.config.item.action.responseCopied': 'Kopiert!',
  'fabric.editor.ai.config.item.action.responseCopiedToClipboard': 'In Zwischenablage kopiert',
  'fabric.editor.ai.config.item.action.retryPrompt': 'Erneut versuchen',
  'fabric.editor.ai.experience-application.documentInsertError':
    'Beim Einfügen der Antwort ist ein Problem aufgetreten. Schließen Sie das Dialogfeld und versuchen Sie es dann erneut.',
  'fabric.editor.ai.experience-application.tokenLimitExceeded':
    'Es konnte keine Antwort abgerufen werden. Ihr Prompt oder Ihre Antwort hat das Limit für diese Anfrage überschritten. Schließen Sie das Dialogfeld und versuchen Sie es dann erneut.',
  'fabric.editor.ai.experience.apiError': 'Wir haben keine Antwort erhalten. Bitte versuchen Sie es erneut.',
  'fabric.editor.ai.experience.commandPaletteAriaName': 'Atlassian Intelligence',
  'fabric.editor.ai.experience.commandPaletteV2Placeholder': 'Teilen Sie der KI mit, was sie tun soll …',
  'fabric.editor.ai.experience.inputTooShortError':
    'Der Inhalt ist zu kurz, um ihn zusammenzufassen. Bitte fügen Sie mehr Inhalt hinzu und versuchen Sie es erneut.',
  'fabric.editor.ai.experience.loadingAriaNewTitle': 'Rovo arbeitet',
  'fabric.editor.ai.experience.loadingAriaTitle': 'Wird erstellt',
  'fabric.editor.ai.experience.loadingEditingTitle': 'Rovo bearbeitet',
  'fabric.editor.ai.experience.previewScreenLabel': 'Vorschau',
  'fabric.editor.ai.experience.rovoAgents.agentPalette.placeholder':
    'Bitten Sie den Agenten, etwas zu schreiben, oder wählen Sie unten eine Option aus.',
  'fabric.editor.ai.experience.rovoAgents.productLabel': 'Rovo',
  'fabric.editor.ai.experience.rovoAgents.productLogoAltText': 'Rovo-Logo',
  'fabric.editor.ai.screens.UserInputCommamdPalette.footerText': 'Atlassian Intelligence',
  'fabric.editor.ai.screens.discard.cancelLabel': 'Zurück',
  'fabric.editor.ai.screens.discard.discardLabel': 'Verwerfen',
  'fabric.editor.ai.screens.discard.noLabel': 'Nein',
  'fabric.editor.ai.screens.error.warningIconLabel': 'Warnung',
  'fabric.editor.ai.screens.discard.yesLabel': 'Ja',
  'fabric.editor.ai.screens.error.ariaErrorTitle': 'Fehler',
  'fabric.editor.ai.screens.error.cancelLabel': 'Abbrechen',
  'fabric.editor.ai.screens.error.closeLabel': 'Schließen',
  'fabric.editor.ai.screens.error.retryLabel': 'Erneut versuchen',
  'fabric.editor.ai.screens.loading.adfContentAriaLiveRegionDescription': 'Live aktualisierende Inhalte:',
  'fabric.editor.ai.screens.loading.iconAltText': 'Symbol wird generiert',
  'fabric.editor.ai.screens.noImprovement.noImprovementMessage': 'Keine Verbesserungen – gute Arbeit!',
  'fabric.editor.ai.screens.noImprovement.successIconLabel': 'Erfolgreich',
  'fabric.editor.ai.screens.preview.actionButtonsAccept': 'Akzeptieren',
  'fabric.editor.ai.screens.preview.actionButtonsAccessibleLabel': 'Aktionen für KI-generierte Inhalte',
  'fabric.editor.ai.screens.preview.actionButtonsTryAgain': 'Erneut versuchen',
  'fabric.editor.ai.screens.preview.betaLabel': 'Beta',
  'fabric.editor.ai.screens.preview.cancelLabel': 'Abbrechen',
  'fabric.editor.ai.screens.preview.compactFeedbackText': 'Hilfreich?',
  'fabric.editor.ai.screens.preview.defaultAIPlaceholder': 'Teilen Sie AI mit, was Sie als Nächstes tun möchten.',
  'fabric.editor.ai.screens.preview.discardLabel': 'Verwerfen',
  'fabric.editor.ai.screens.preview.disclaimer': 'Die Qualität der Informationen kann variieren.',
  'fabric.editor.ai.screens.preview.disclaimerLink': 'Weitere Informationen',
  'fabric.editor.ai.screens.preview.header.clear.hover': 'Löschen',
  'fabric.editor.ai.screens.preview.header.edit': 'Aufforderung bearbeiten',
  'fabric.editor.ai.screens.preview.header.edit.hover': 'Bearbeiten',
  'fabric.editor.ai.screens.preview.placeholderWithAgent': '{agentName} fragen, was als Nächstes zu tun ist',
  'fabric.editor.ai.screens.preview.refineButton': 'Präzisieren',
  'fabric.editor.ai.screens.preview.refineDropdown.refineButton': 'Präzisieren',
  'fabric.editor.ai.screens.prompt.logoAltText': 'Logo von Atlassian Intelligence',
  'fabric.editor.ai.screens.prompt.logoText': 'Atlassian Intelligence',
  'fabric.editor.ai.screens.prompt.streaming.insertMenu.addLink': 'Link hinzufügen',
  'fabric.editor.ai.screens.prompt.streaming.insertMenu.mention': 'Benutzer erwähnen',
  'fabric.editor.ai.screens.prompt.streaming.insertMenu.triggerLabel': 'Erweiterte Inhalte einfügen',
  'fabric.editor.ai.screens.prompt.streaming.placeholder': 'Beschreiben Sie, was Sie tun möchten',
  'fabric.editor.ai.screens.prompt.streaming.record': 'Aufzeichnen',
  'fabric.editor.ai.screens.prompt.streaming.submit': 'Senden',
  'fabric.editor.ai.screens.prompt.submitLabel': 'Senden',
  'fabric.editor.ai.screens.prompt.submitTooltip': 'An AI senden',
  'fabric.editor.ai.screens.promptWithSelectedOption.promptSelected': '{promptName} – ausgewählt',
  'fabric.editor.ai.screens.promptWithSelectedOption.removeLabel': 'Entfernen',
  'fabric.editor.ai.shared.aiProactiveButtonLabel': 'Vorschläge',
  'fabric.editor.ai.shared.aiUniversalDescriptor': 'Schreibassistent',
  'fabric.editor.ai.shared.aiUniversalLongCallToAction':
    'Lassen Sie sich von Atlassian Intelligence beim Schreiben unterstützen',
  'fabric.editor.ai.shared.aiUniversalShortCallToAction': 'Schreiben',
  'fabric.editor.ai.shared.betaLabel': 'Beta',
  'fabric.editor.ai.shared.generateContent.aiButtonTitle': 'AI (Atlassian Intelligence)',
  'fabric.editor.ai.ui.components.suggestions.betaLozenge': 'BETA',
  'fabric.editor.ai.ui.components.suggestions.newLozenge': 'NEU',
  'fabric.editor.ai.ui.components.suggestions.tellAILabel': 'Antwort an AI:',
  'fabric.editor.ai.ui.components.suggestions.tellAgentLabel': 'Information für Agenten:',
};
